import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mst_entity_applet_catalog_link_RowClass} from '../../../dbschema';

export class EntityAppletCatalogLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_applet_catalog_link: bl_fi_mst_entity_applet_catalog_link_RowClass = new bl_fi_mst_entity_applet_catalog_link_RowClass();
}
